import { Component, signal, OnInit, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from "@angular/router";
import { SettingsStorageService } from '../../services/settings-storage.service';
import { CacheService, AuthService } from '../../services';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.css'
})
export class SideNavComponent implements OnInit {

  private settingsStorage = inject(SettingsStorageService);
  private cacheService = inject(CacheService);
  private authService = inject(AuthService);

  logoUrl = 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Logo_NIKE.svg';

  isLocked = signal(false);
  showSettings = signal(false);

  navItems = signal([
    {
      name: 'Dashboard',
      link: '/buy-sheet-view',
      iconPath: 'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z',
      enabled: true
    },
    {
      name: 'Buy File Upload',
      link: '/buy-upload',
      iconPath: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
      enabled: true
    },
    {
      name: 'PCU File Upload',
      link: '/pcu-upload',
      iconPath: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
      enabled: true
    },
    {
      name: 'Report',
      link: '/report',
      iconPath: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
      enabled: true
    }
  ]);

  settingsItem = signal({
    name: 'Settings',
    link: '/settings',
    enabled: true
  });

  async ngOnInit() {
    try {
      const savedSettings = await this.settingsStorage.loadSettings();
      this.isLocked.set(savedSettings.isLocked);
    } catch (error) {
      console.error('Error loading settings:', error);
    }
  }

  async toggleLock() {
    const newLockState = !this.isLocked();
    this.isLocked.set(newLockState);

    try {
      await this.settingsStorage.saveSettings({ isLocked: newLockState });
    } catch (error) {
      console.error('Error saving settings:', error);
    }
  }

  openSettings() {
    this.showSettings.set(true);
  }

  closeSettings() {
    this.showSettings.set(false);
  }

  clearCache(): void {
    this.cacheService.clearAll().subscribe({
      next: () => {
        window.location.reload();
        console.log('Cache cleared successfully');
      },
      error: (error) => {
        console.error('Failed to clear cache:', error);
      }
    });
  }

  logout() {
    this.authService.signOut();
  }
}
